import React, {PureComponent} from "react";
import withStyles from '@mui/styles/withStyles';
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import {PageDataContext} from "../../../core/PageDataContext";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import moment from "moment";
import {Typography} from "@mui/material";
import Zoom from "@mui/material/Zoom";
import Divider from "@mui/material/Divider";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Skeleton from '@mui/material/Skeleton';
import {SentimentVeryDissatisfied, SentimentVerySatisfied} from "@mui/icons-material";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import EditIcon from "@mui/icons-material/Edit";
import WorkoutCompleteEditForm from "../partials/WorkoutCompleteEditForm";
import {withRouter} from "../../../hooks/withRouter";
import Slide from "@mui/material/Slide";
import WorkoutLogsSection from "../partials/WorkoutLogsSection";
import PersonalRecordBanner from "../partials/PersonalRecordBanner";
import {UserContext} from "../../../core/UserContext";
import AiChatButton from "../../ai/AiChatButton";
import ShareWorkoutButton from "../partials/ShareWorkoutButton";
import WorkoutInsightCard from "../../ai/WorkoutInsightCard";
import AchievementUnlockedBanner from "../partials/AchievementUnlockedBanner";
import FinishAnimationOverlay from "../../customize/partials/FinishAnimationOverlay";
import Paper from "@mui/material/Paper";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import BarChartIcon from "@mui/icons-material/BarChart";
import TimerIcon from "@mui/icons-material/Timer";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const useStyles = theme => ({
	media: {
		height: 125,
	},
	button: {
		minWidth: '30px',
		width: '30px',
		height: '30px',
		padding: '0',
	},
});

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class WorkoutDetail extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			workout: null,
			isLoading: true,
			isGraphsLoading: true,
			showWorkoutDoneMessage: Boolean((new URLSearchParams(this.props.location.search)).get('just_finished') !== null),
			workoutDoneMessage: this.getWorkoutDoneMessage(),
			isDeleteConfirmationDialogOpen: false,
			dropDownCommentAnchorEl: null,
			isWorkoutEditFormOpen: false,
			personalRecords: [],
		};
	}

	componentDidMount() {
		this.fetchWorkout();
	}

	getNumberOfExercisesDone = (workout) => {
		let total = 0;
		workout.routines?.forEach(routine => {
			total += routine.exercises.length;
		});
		return total;
	}

	getTotalSets = (workout) => {
		let total = 0;
		workout.routines?.forEach(routine => {
			routine.exercises.forEach(exercise => {
				total += exercise.logs?.length || 0;
			});
		});
		return total;
	}

	fetchWorkout = async () => {
		this.setState({
			isLoading: true
		});

		const response = await fetch(UrlBuilder.workout.workoutsApi(this.props.params.workoutId))
			.then(response => response.json());

		let workout = response.data;

		this.setState({
			workout: workout,
			isLoading: false
		});
		this.context.setPageData({
			title: workout.name,
		});

		fetch(UrlBuilder.workout.personalRecordsApi(workout.id))
			.then(res => res.json())
			.then(res => {
				this.setState({personalRecords: res.data || []});
			});
	}

	getWorkoutDoneMessage = () => {
		let messages = [
			'Good work!',
			'Good job!',
			'Great work!',
			'Great job!',
		];

		return messages[Math.floor(Math.random() * messages.length)];
	}

	deleteSelf = async (e) => {
		e.preventDefault();

		await fetch(UrlBuilder.workout.workoutsApi(this.state.workout.id), {
			method: 'DELETE',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
		});

		this.props.navigate('/');
	}

	openWorkoutDeleteConfirmationDialog = (isOpen) => {
		this.setState({
			isDeleteConfirmationDialogOpen: isOpen
		})
	}

	renderMood = (moodLevel) => {
		switch (moodLevel) {
			case 1:
				return <SentimentVeryDissatisfied color='secondary'/>;
			case 2:
				return <SentimentSatisfiedIcon color='secondary'/>;
			case 3:
				return <SentimentVerySatisfied color='secondary'/>
		}
	}

	openWorkoutEditForm = (isOpen, shouldRefresh = false) => {
		if (shouldRefresh) {
			this.fetchWorkout();
		}
		this.setState({
			isWorkoutEditFormOpen: isOpen,
		});
	}

	renderDeleteConfirmationDialog = () => {
		if (!this.state.isDeleteConfirmationDialogOpen) {
			return null;
		}

		return <Dialog open={true} onClose={() => this.openWorkoutDeleteConfirmationDialog(false)} TransitionComponent={Transition}>
			<DialogTitle>{"Are you sure you want to delete this workout?"}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Deleting it will remove its corresponding logs. This cannot be undone.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={() => this.openWorkoutDeleteConfirmationDialog(false)} sx={{ textTransform: 'none' }}>
					Cancel
				</Button>
				<Button variant='contained' onClick={this.deleteSelf} color="primary" autoFocus sx={{ textTransform: 'none' }}>
					Delete
				</Button>
			</DialogActions>
		</Dialog>
	}

	renderStatCard = (icon, label, value, detail) => {
		return (
			<Paper variant="outlined" sx={{
				borderRadius: 2,
				p: 1.5,
				textAlign: 'center',
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			}}>
				<Box sx={{ color: 'text.secondary', mb: 0.5 }}>
					{icon}
				</Box>
				<Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
					{value}
				</Typography>
				<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
					{label}
				</Typography>
				{detail && (
					<Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 10, mt: 0.25 }}>
						{detail}
					</Typography>
				)}
			</Paper>
		);
	}

	renderPage = () => {
		const numberOfExercisesDone = this.getNumberOfExercisesDone(this.state.workout);
		const totalSets = this.getTotalSets(this.state.workout);

		const dateTimeStarted = moment(this.state.workout.dateTimeStarted);
		const dateTimeEnded = moment(this.state.workout.dateTimeEnded);
		let workoutDurationObj = moment.duration(dateTimeEnded.diff(dateTimeStarted));
		let workoutDuration = moment.utc(workoutDurationObj.asMilliseconds()).format('HH:mm');
		let timeRange = dateTimeStarted.format('LT') + " — " + dateTimeEnded.format('LT');

		return <>
			<Box sx={{ pt: 1.5 }} />

			{this.state.showWorkoutDoneMessage ? (
				<>
					<UserContext.Consumer>
						{({user}) => user?.equippedFinishAnimationId && (
							<FinishAnimationOverlay animationId={user.equippedFinishAnimationId} />
						)}
					</UserContext.Consumer>
					<Zoom in>
						<Box display="flex" justifyContent="center" alignItems="center" minHeight="10vh">
							<Typography variant="h3" gutterBottom>
								{this.state.workoutDoneMessage} 🏆
							</Typography>
						</Box>
					</Zoom>
				</>
			) : null}

			<UserContext.Consumer>
				{({user}) => (
					<PersonalRecordBanner
						personalRecords={this.state.personalRecords}
						animated={this.state.showWorkoutDoneMessage}
						prStyleId={user?.equippedPrStyleId}
					/>
				)}
			</UserContext.Consumer>

			<AchievementUnlockedBanner justFinished={this.state.showWorkoutDoneMessage} />

			<UserContext.Consumer>
				{({user}) => (
					user.features?.includes('ai_features') &&
					<WorkoutInsightCard
						workoutId={this.state.workout.id}
						showWorkoutDoneMessage={this.state.showWorkoutDoneMessage}
					/>
				)}
			</UserContext.Consumer>

			{/* Stat cards */}
			<Grid container spacing={1}>
				<Grid item xs={4}>
					{this.renderStatCard(
						<FitnessCenterIcon sx={{ fontSize: 20 }} />,
						'Exercises',
						numberOfExercisesDone,
						totalSets > 0 ? `${totalSets} sets` : null,
					)}
				</Grid>
				<Grid item xs={4}>
					{this.renderStatCard(
						<BarChartIcon sx={{ fontSize: 20 }} />,
						'Volume',
						this.state.workout.totalVolume,
						'Total',
					)}
				</Grid>
				<Grid item xs={4}>
					{this.renderStatCard(
						<TimerIcon sx={{ fontSize: 20 }} />,
						'Duration',
						workoutDuration,
						timeRange,
					)}
				</Grid>
			</Grid>

			{this.renderDeleteConfirmationDialog()}

			{/* Date and Action Buttons */}
			<Box sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				mt: 2,
				mb: 0.5,
			}}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
					<AccessTimeIcon sx={{ fontSize: 15, color: 'text.disabled' }} />
					<Typography variant="caption" sx={{ color: 'text.secondary' }}>
						{dateTimeStarted.fromNow()} — {dateTimeStarted.calendar()}
					</Typography>
				</Box>

				<Box display="flex" gap={0.75} alignItems="center">
					<ShareWorkoutButton workout={this.state.workout} />
					<IconButton
						size="small"
						onClick={() => this.openWorkoutEditForm(true)}
						sx={{ border: 1, borderColor: 'divider', borderRadius: 1.5, width: 30, height: 30 }}
					>
						<EditIcon sx={{ fontSize: 16 }} />
					</IconButton>
					<IconButton
						size="small"
						onClick={() => this.openWorkoutDeleteConfirmationDialog(true)}
						sx={{ border: 1, borderColor: 'divider', borderRadius: 1.5, width: 30, height: 30 }}
					>
						<DeleteIcon sx={{ fontSize: 16 }} />
					</IconButton>
				</Box>
			</Box>

			{/* Mood and Notes */}
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 1 }}>
				{this.state.workout.moodLevel ? (
					<Box display="flex" alignItems="center" gap={0.5}>
						<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
							Mood:
						</Typography>
						<IconButton sx={{ p: 0 }} size="small">
							{this.renderMood(this.state.workout.moodLevel)}
						</IconButton>
					</Box>
				) : null}

				{this.state.workout.comment ? (
					<Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
						<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
							Notes:
						</Typography>
						<Typography variant="body2">
							{this.state.workout.comment}
						</Typography>
					</Box>
				) : null}
			</Box>

			<WorkoutCompleteEditForm
				workout={this.state.workout}
				isOpen={this.state.isWorkoutEditFormOpen}
				closeSelfFunc={(shouldRefresh) => this.openWorkoutEditForm(false, shouldRefresh)}
			/>

			<Divider sx={{ my: 2 }} />

			<div style={{ float: 'right' }}>
				<UserContext.Consumer>
					{({user, setUser}) => (
						user.features?.includes('ai_features') &&
						<AiChatButton
							apiUrl={UrlBuilder.ai.summarizeWorkout(this.state.workout.id)}
							pageContext={`workout/${this.state.workout.id}`}
							defaultActionLabel="Summarize this workout"
							presetSuggestions={[
								"What's my strongest lift?",
								"Which muscles need more focus?",
								"Which lifts could I improve?",
								"Should I increase weight next session?",
								"How does this compare to my previous workout?",
								"Did I hit a new PR here?",
								"How was my volume vs last time?",
								"Any imbalances I should fix?",
								"Did I push close to failure?",
								"What was my best set?",
							]}
						/>
					)}
				</UserContext.Consumer>
			</div>

			<WorkoutLogsSection workout={this.state.workout} personalRecords={this.state.personalRecords} />
		</>;
	}

	renderLoadingSkeletons = () => {
		return <>
			<Box sx={{ pt: 1.5 }} />

			{/* Stat cards */}
			<Grid container spacing={1}>
				{[1, 2, 3].map(i => (
					<Grid item xs={4} key={i}>
						<Paper variant="outlined" sx={{ borderRadius: 2, p: 1.5, textAlign: 'center' }}>
							<Skeleton variant="circular" width={20} height={20} sx={{ mx: 'auto', mb: 0.5 }} />
							<Skeleton variant="text" width="50%" sx={{ mx: 'auto', fontSize: 24 }} />
							<Skeleton variant="text" width="60%" sx={{ mx: 'auto', fontSize: 12 }} />
						</Paper>
					</Grid>
				))}
			</Grid>

			{/* Time + actions */}
			<Box sx={{ mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
					<Skeleton variant="circular" width={15} height={15} />
					<Skeleton variant="text" width={160} sx={{ fontSize: 12 }} />
				</Box>
				<Box sx={{ display: 'flex', gap: 0.75 }}>
					<Skeleton variant="rounded" width={30} height={30} sx={{ borderRadius: 1.5 }} />
					<Skeleton variant="rounded" width={30} height={30} sx={{ borderRadius: 1.5 }} />
				</Box>
			</Box>

			<Divider sx={{ my: 2 }} />

			{/* Exercise log skeletons */}
			{[1, 2].map(i => (
				<Box key={i} sx={{ mb: 2 }}>
					<Skeleton variant="text" width={140} sx={{ fontSize: 20, mb: 1 }} />
					{[1, 2].map(j => (
						<Box key={j} sx={{ mb: 1.5 }}>
							<Box sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}>
								<Skeleton variant="circular" width={24} height={24} sx={{ mr: 1.5 }} />
								<Skeleton variant="text" width="40%" sx={{ fontSize: 14 }} />
							</Box>
							{[1, 2, 3].map(k => (
								<Box key={k} sx={{ display: 'flex', alignItems: 'center', pl: 5, mb: 0.25 }}>
									<Skeleton variant="text" width={16} sx={{ mr: 1.5, fontSize: 13 }} />
									<Skeleton variant="text" width={`${30 + k * 10}%`} sx={{ fontSize: 13 }} />
								</Box>
							))}
						</Box>
					))}
				</Box>
			))}
		</>;
	}

	render() {
		return <div>
			{this.state.isLoading ?
				this.renderLoadingSkeletons()
				: this.renderPage()
			}
		</div>
	}
}

WorkoutDetail.contextType = PageDataContext;

export default withStyles(useStyles)(withRouter(WorkoutDetail));
